import { RealtimeNotifications as RealtimeMessages } from '@fiverr-private/realtime_notifications';

export default RealtimeMessages;
